import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectAdminToken } from "../../admin/sessionSlice";
import { isGameOver } from "../../functions/stageReportSync";
import { setBackButtonUrl } from "../uiSlice";
import { UI } from "./desiAssets";
import { TOTAL_GAMES, WELCOME_ROUTE } from "./gameConfig";
import {
  getBackendBase,
  getStoredUser,
  isDemoUser,
  loadPlayerStage,
  playedLevels,
  sumGameScores,
} from "./gameUtils";
import useDesiBackground from "./useDesiBackground";
import "./desi.css";

/** thankyou.php — shown once all six states have been played. */
function ThankYou() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const adminToken = useSelector(selectAdminToken);
  const storedUser = useMemo(() => user || getStoredUser(), [user]);
  const isDemoBypass = useMemo(() => isDemoUser(storedUser), [storedUser]);

  const [summary, setSummary] = useState(null);

  useDesiBackground();

  useEffect(() => {
    dispatch(setBackButtonUrl("/thankyou"));
  }, [dispatch]);

  useEffect(() => {
    if (!storedUser?.userId && !storedUser?.id) {
      navigate("/", { replace: true });
      return undefined;
    }
    let cancelled = false;
    (async () => {
      const { stage } = await loadPlayerStage({
        backendBase: getBackendBase(),
        adminToken,
        storedUser,
        isDemoBypass,
      });
      if (cancelled) return;
      if (
        stage &&
        !isGameOver(stage) &&
        playedLevels(stage).length < TOTAL_GAMES
      ) {
        navigate(WELCOME_ROUTE, { replace: true });
        return;
      }
      const total = stage?.total_score;
      setSummary({
        time: String(stage?.time || "00:00"),
        points:
          total != null && Number.isFinite(Number(total))
            ? Number(total)
            : sumGameScores(stage),
      });
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="desi-page thankyou">
      <img className="thankyou__logo" src={UI.thankyouGif} alt="Thank you" />
      {summary ? (
        <p className="thankyou__score">
          Congrats on completing the race in {summary.time} minutes!
          <br />
          You scored {summary.points}.
        </p>
      ) : null}
    </div>
  );
}

export default ThankYou;
